var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (jsonLD) {
buf.push("<script id=\"json-ld\" type=\"application/ld+json\">" + (null == (jade_interp = [jsonLD]) ? "" : jade_interp) + "</script>");}.call(this,"jsonLD" in locals_for_with?locals_for_with.jsonLD:typeof jsonLD!=="undefined"?jsonLD:undefined));;return buf.join("");
};
module.exports = template;